var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBottomStreamlineUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.001 3.75v12m-4.5-4.5 4.5 4.5 4.5-4.5m6.75 4.5v1.5a3 3 0 0 1-3 3h-16.5a3 3 0 0 1-3-3v-1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBottomStreamlineUltimate);
export default __webpack_public_path__ + "static/media/Download-Bottom--Streamline-Ultimate.cfff1c17b8f0398d20cd0d844d5659d4.svg";
export { ForwardRef as ReactComponent };